import { createStore } from 'vuex'

export default createStore({
  state: {
    propertiesSearchEnabled: true
  },
  getters: {
    isPropertiesSearchEnabled: (state) => state.propertiesSearchEnabled
  },
  mutations: {
    SET_PROPERTIES_SEARCH_ENABLED(state, value) {
      state.propertiesSearchEnabled = Boolean(value);
    }
  },
  actions: {
    updatePropertiesSearchEnabled({ commit }, value) {
      commit('SET_PROPERTIES_SEARCH_ENABLED', value);
    }
  },
  modules: {
  }
})

